import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "18",
  fill: "none",
  viewBox: "0 0 19 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#44403c",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.67",
      d: "M1.058 1h1.597l2.124 9.96a1.592 1.592 0 0 0 1.597 1.267h7.808c.364 0 .716-.125.999-.354s.48-.548.558-.904l1.317-5.959H3.51m3.098 11.188A.8.8 0 0 1 5.81 17a.8.8 0 0 1-.799-.802.8.8 0 0 1 .799-.802.8.8 0 0 1 .798.802m8.783 0a.8.8 0 0 1-.799.802.8.8 0 0 1-.798-.802.8.8 0 0 1 .798-.802.8.8 0 0 1 .799.802"
    }, null, -1)
  ]))]))
}
export default { render: render }